import {IDropupParams} from "@/models/BasicModels";

export const defaultDropupParam: IDropupParams = {
  hasButton: true,
  hiddenInClose: false,
  openInHalf: false,
  dropUpColor: "#1A1346",
};

export const selectHubDropupParams: IDropupParams = {
  hasButton: false,
  hiddenInClose: true,
  openInHalf: false,
  dropUpColor: "#98e2f9",
};

export const defaultHubDropupParams: IDropupParams = {
  hasButton: true,
  hiddenInClose: true,
  openInHalf: false,
  dropUpColor: "#98e2f9",
};



